import React, { PropsWithChildren } from "react";
import styled from "@emotion/styled";

const TabContentStyled = styled.div`
  position: relative;
  flex: 1;
  overflow: hidden;
`;

const PanelStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: var(--builder-panel-background);
  box-shadow: inset 0px 0px 0px 1px transparent;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
`;

const PanelContentStyled = styled.div`
  margin-right: 0;
  padding: 0 0 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const PanelListStyled = styled.div`
  flex: 1;
  overflow: auto;
`;

export const TabContent: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <TabContentStyled>
        <PanelStyled>
          <PanelContentStyled>
            <PanelListStyled>{children}</PanelListStyled>
          </PanelContentStyled>
        </PanelStyled>
      </TabContentStyled>
    </>
  );
};
